import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

/**
 * Dialogs can be nested. This example opens a Date Picker from within a Dialog.
 */
export default class LocationTableDialog extends React.Component {
  state = {
    open: false,
  };

  constructor(props){
    super(props);
    this.state = {
      open: props.show,
      beaconId: props.table? props.table.beaconId: '',
      name: props.table? props.table.name: ''
    };
  }

  componentWillReceiveProps(newProps){
    this.setState({
      beaconId: newProps.table? newProps.table.beaconId: '',
      name: newProps.table? newProps.table.name: ''
    })
  }

  handleClose = () => {
    if (this.props.beaconUpdated){
      this.props.beaconUpdated({
        locationId: this.props.table.location, 
        tableId: this.props.table._id, 
        beaconId: this.state.beaconId,
        name: this.state.name
      });
    }

  };

  updateBeacon = (event) => {
    this.setState({beaconId: event.target.value});
  }
  updateName = (event) => {
    this.setState({name: event.target.value});
  }

  render() {
    if (!this.props.table) {
      return <div></div>;
    }
    const actions = [
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.handleClose}
      />,
    ];

    let dialogTitle = `Update Table ${this.props.table.name} Beacon Id`;

    return (
      <div>
        <Dialog
          title={dialogTitle}
          actions={actions}
          modal={true}
          open={this.props.show}
          onRequestClose={this.handleClose}
        >
          <label>Table Name</label><br/><input type="text" placeholder="Table Name/Number" value={this.state.name} onChange={this.updateName}/><br/>
          <label>Beacon ID</label><br/><input type="text" placeholder="Beacon ID" value={this.state.beaconId} onChange={this.updateBeacon}/>
        </Dialog>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Locations/LocationTableDialog.js